/**
 * Prefix for authenticated app routes (onboarding, home, auth, profile).
 * Marketing landing stays at `/`.
 */
export const LUMIO_APP_ROUTE_PREFIX = '/app';
